






















































































































































































































































































































































































































































declare var window: any;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { JobFilterWrapper } from '@/models/jobs/jobfilterwrapper';
import { JobFilter } from '@/models/jobs/jobfilter';
import { ATSJobListParams } from '../models/jobs/atsjoblistparams';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns';
import rangeSlider from './Commons/rangeSlider.vue';
import { CommonJobAlert } from '../models/JobAlert/commonjobalert';
import { AlertConfigDetails } from '../models/JobAlert/alertconfigdetails';
import { Geolocation } from '../models/jobs/geolocation';
import { Latlong } from '../models/jobs/latlong';
import { Locale } from '../models/jobs/locale';
import { JobAlertUI } from '../models/JobAlert/JobAlertUI';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

MultiSelect.Inject(CheckBoxSelection);
Vue.use(MultiSelectPlugin);

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  name: 'Searchbox',
  components: {
    VueGoogleAutocomplete,
    rangeSlider,
    Treeselect,
  },
})
export default class Searchbox extends Vue {
  @Prop() jobAlertId;
  $wlToastr: any;
  private jobListParams: ATSJobListParams = new ATSJobListParams();
  private jobListParamsXS: ATSJobListParams = new ATSJobListParams();
  private jobFilterWrapper: JobFilterWrapper = new JobFilterWrapper();
  private address: string = '';
  private map: string = '';
  private fields = { text: 'text', value: 'value' };

  private industry: number = 0;
  private shift: number = 0;
  private jobSkill: number = 0;
  private jobSkillArray: number[] = [];
  private candidatePlacementType: string = '';

  private industryXL: any = [];
  private shiftXL: any = '';
  private jobSkillXL: number = 0;
  private jobSkillXLArray: any = [];
  private jobTagsArray: string[] = [];
  private candidatePlacementTypeXL: string = '';
  private remoteJobType: string[] = [];
  private addressSearchText: string = '';
  private range: number = 10;
  private previousRadius: number = 10;
  private panelBodyVisibility: boolean = false;
  private minimumSearchDistance: number = 5;
  private maximumSearchDistance: number = 3250;
  private isRangeSelectorDisabled: boolean = false;
  private locationType: string = '';
  private locShortName: string = '';
  private INACTIVE_SORT_COLOR_CODE: string = '#707070';
  private ACTIVE_SORT_COLOR_CODE: string = 'rgb(61, 145, 242)';
  private activeDescColor: string = '';
  private activeAscColor: string = '';
  private jobType: string = 'Job Type';
  private selectedCategory = [];
  private categories = [];
  private skillid: number = 0;
  private industryid: number = 0;
  private cityId: number = 0;
  private facilityTypes: any = [];
  private selectedDiscipline: any = '';

  $refs!: {
    address_filter: HTMLFormElement;
  };

  get facilityTypesOptions() {
    const facilityTypeOptions = vxm.jobs.CustomFilters.find(
      (filter) => filter.displayId === 'customInt5',
    );
    if (facilityTypeOptions) {
      return facilityTypeOptions.options;
    }
    return [];
  }

  get disciplineOptions() {
    const disciplineOptions = vxm.jobs.CustomFilters.find(
      (filter) => filter.display === 'Discipline',
    );
    if (disciplineOptions) {
      return disciplineOptions.options;
    }
    return [];
  }

  formatCategories(categories) {
    const parentCategories = categories.filter(
      (category) => !category.parentCategoryId,
    );
    const childCategories = categories.filter(
      (category) => category.parentCategoryId,
    );
    return parentCategories.map((category) => {
      let children = childCategories
        .filter(
          (childCategory) =>
            childCategory.parentCategoryId === category.categoryId,
        )
        .map((filteredCategory) => {
          return {
            id: filteredCategory.categoryId,
            label: filteredCategory.name,
          };
        });
      return {
        id: category.categoryId,
        label: category.name,
        children: children.length ? children : null,
      };
    });
  }

  get appTheme() {
    return vxm.utility.AppTheme;
  }

  getArray() {
    console.log(this.jobSkillXLArray);
  }

  get appliedFilterRadius(): number {
    return vxm.jobs.FilterRadius;
  }

  get shiftTypes() {
    const shiftTypeField = vxm.jobs.CustomFilters.find(
      (filter) => filter.displayId === 'ShiftType',
    );
    const options = [{ value: '', name: 'Shift type' }];
    if (shiftTypeField) {
      shiftTypeField.options.forEach((option) => {
        options.push({
          value: option.value,
          name: option.text,
        });
      });
    }
    return options;
  }

  @Watch('appliedFilterRadius')
  onPropertyChanged(value: number, oldValue: number) {
    console.log(value, '**New Valuew');
    this.range = value;
  }

  //@Watch('jfWrapper', { immediate: true })
  async onGetCandidatePlacementTypes() {
    const filterUrl = this.$route.params.filterUrl;
    if (filterUrl) {
      const matchedItems = filterUrl.match(
        /(.*)-placement-type-(.*)-industry-(.*)-jobskill-(.*)-shift-(.*)-remote-job-type-job-search-by-(.*)-within-(.*)-miles-from-(.*)-sort-by-(.*)-in-(.*)-order-(.*)-facility-types/i,
      );
      if (matchedItems) {
        let placementType = matchedItems[1];
        placementType = placementType.replace(/-/g, '-');
        const item = this.candidatePlacementTypes.find(
          (type) =>
            type.text.toLowerCase().replace(/ |\//g, '-') === placementType,
        );
        this.candidatePlacementTypeXL = item ? item.value : '';
        let industries = matchedItems[2];
        if (industries !== 'any') {
          this.industryXL = industries.split('_').map((industry) => {
            const industryVertical = this.industryVerticals.find(
              (vertical) =>
                vertical.text.toLowerCase().replace(/ |\//g, '-') === industry,
            );
            return (industryVertical && industryVertical.value) || 0;
          });
        }

        let jobSkills = matchedItems[3];
        if (jobSkills !== 'any') {
          this.jobSkillXLArray = jobSkills.split('_').map((skill) => {
            const jobSkill = this.jobSkills.find(
              (vertical) =>
                vertical.text.toLowerCase().replace(/ |\//g, '-') === skill,
            );
            return (jobSkill && jobSkill.value) || 0;
          });
        }

        let shiftText = matchedItems[4];
        if (shiftText === 'any') {
          this.shiftXL = '';
        } else {
          const selectedShiftType = this.shiftTypes.find(
            (type) =>
              type.name.replace(/ |\//g, '-').toLowerCase() === shiftText,
          );
          if (selectedShiftType) {
            this.shiftXL = selectedShiftType.value;
          } else {
            this.shiftXL = '';
          }
        }

        let remoteJob = matchedItems[5];
        console.log('Remote Job Type matched - ', remoteJob);
        if (remoteJob === 'any') {
          this.remoteJobType = [];
        } else if (
          remoteJob.includes('yes') &&
          remoteJob.includes('no') &&
          remoteJob.includes('partial')
        ) {
          this.remoteJobType = ['yes', 'no', 'partial'];
        } else if (remoteJob.includes('yes') && remoteJob.includes('no')) {
          this.remoteJobType = ['yes', 'no'];
        } else if (remoteJob.includes('yes') && remoteJob.includes('partial')) {
          this.remoteJobType = ['yes', 'partial'];
        } else if (remoteJob.includes('no') && remoteJob.includes('partial')) {
          this.remoteJobType = ['no', 'partial'];
        } else if (remoteJob.includes('yes')) {
          this.remoteJobType = ['yes'];
        } else if (remoteJob.includes('no')) {
          this.remoteJobType = ['no'];
        }

        this.jobListParams.keywords =
          matchedItems[6] === 'any' ? '' : matchedItems[6];

        this.range = Number(matchedItems[7]);

        const locationInfo = matchedItems[8];

        if (locationInfo !== 'provided-location') {
          const locationText = locationInfo.replace(/-/g, ', ');
          this.jobListParams.location = locationText;
          this.$refs.address_filter.update(locationText);
          this.addressSearchText = locationText;
          const response = await vxm.utility.getLatitudeLongitude({
            locationText,
          });
          this.jobListParams.geoLocation.latLong.latitude = response.latitude;
          this.jobListParams.geoLocation.latLong.longitude = response.longitude;
          this.locationType = response.locationType;
          this.locShortName = response.locShortName;
        }
        const sortFieldText = matchedItems[9];
        switch (sortFieldText) {
          case 'pay':
            this.jobListParams.sortCriteria.sortField = '02';
            break;
          case 'start-date':
            this.jobListParams.sortCriteria.sortField = '03';
            break;
          case 'date-added':
            this.jobListParams.sortCriteria.sortField = '01';
            break;
          default:
            this.jobListParams.sortCriteria.sortField = '01';
            break;
        }
        const sortOrderAscText = matchedItems[10];
        this.jobListParams.sortCriteria.sortOrderAsc =
          sortOrderAscText === 'ascending';
        this.activeAscColor =
          sortOrderAscText === 'ascending'
            ? this.ACTIVE_SORT_COLOR_CODE
            : this.INACTIVE_SORT_COLOR_CODE;
        this.activeDescColor =
          sortOrderAscText !== 'ascending'
            ? this.ACTIVE_SORT_COLOR_CODE
            : this.INACTIVE_SORT_COLOR_CODE;
        const facilityTypes = matchedItems[11];
        if (facilityTypes === 'any') {
          this.facilityTypes = [];
        } else {
          this.facilityTypes = facilityTypes.split('_').map((type) => {
            const facility = this.facilityTypesOptions.find(
              (option) =>
                option.text.toLowerCase().replace(/ |\//g, '-') === type,
            );
            return facility && facility.value;
          });
        }
      }
      this.filterJobs();
    }
  }

  resetRangeField() {
    this.range = this.previousRadius;
    // this.$refs.rangeslidercomponent.range = 10;
    this.panelBodyVisibility = false;
  }

  setRangeValue(val) {
    this.range = val;
  }

  get userLatitude(): number {
    return vxm.jobs.latitude;
  }

  get userLongitude(): number {
    return vxm.jobs.longitude;
  }

  sortFindJobs() {
    if (this.jobListParams.sortCriteria.sortField === '') {
      this.jobListParams.sortCriteria.sortField = '01';
    }

    if (this.jobListParams.sortCriteria.sortField === '02') {
      this.jobListParams.sortCriteria.sortOrderAsc = false;
      this.activeAscColor = this.INACTIVE_SORT_COLOR_CODE;
      this.activeDescColor = this.ACTIVE_SORT_COLOR_CODE;
    } else {
      this.jobListParams.sortCriteria.sortOrderAsc = false;
      this.activeAscColor = this.INACTIVE_SORT_COLOR_CODE;
      this.activeDescColor = this.ACTIVE_SORT_COLOR_CODE;
    }
    this.filterJobs();
  }

  sortByDescOrder() {
    if (
      this.jobListParams.sortCriteria &&
      this.jobListParams.sortCriteria.sortOrderAsc
    ) {
      this.jobListParams.sortCriteria.sortOrderAsc = false;
      this.activeAscColor = this.INACTIVE_SORT_COLOR_CODE;
      this.activeDescColor = this.ACTIVE_SORT_COLOR_CODE;
    } else if (
      this.jobListParams.sortCriteria &&
      !this.jobListParams.sortCriteria.sortOrderAsc &&
      (this.jobListParams.sortCriteria.sortField === '03' ||
        this.jobListParams.sortCriteria.sortField === '01')
    ) {
      this.jobListParams.sortCriteria.sortOrderAsc = true;
      this.activeAscColor = this.INACTIVE_SORT_COLOR_CODE;
      this.activeDescColor = this.ACTIVE_SORT_COLOR_CODE;
    }
    this.fetchJobs();
  }

  sortByAscOrder() {
    if (
      this.jobListParams.sortCriteria &&
      !this.jobListParams.sortCriteria.sortOrderAsc
    ) {
      this.jobListParams.sortCriteria.sortOrderAsc = true;
      this.activeAscColor = this.ACTIVE_SORT_COLOR_CODE;
      this.activeDescColor = this.INACTIVE_SORT_COLOR_CODE;
    } else if (
      this.jobListParams.sortCriteria &&
      this.jobListParams.sortCriteria.sortOrderAsc &&
      (this.jobListParams.sortCriteria.sortField === '03' ||
        this.jobListParams.sortCriteria.sortField === '01')
    ) {
      this.jobListParams.sortCriteria.sortOrderAsc = false;
      this.activeAscColor = this.ACTIVE_SORT_COLOR_CODE;
      this.activeDescColor = this.INACTIVE_SORT_COLOR_CODE;
    }
    this.fetchJobs();
  }

  applyRadiusAndFilterJobs() {
    this.previousRadius = this.range;
    this.filterJobs();
  }

  filterJobs(seoFreindlyUrl = false) {
    this.getArray();
    this.panelBodyVisibility = false;
    this.jobListParams.resultPage = 1;
    this.jobListParams.geoLocation.requestPref = 'LATLONG';
    this.jobListParams.geoLocation.locationType = this.locationType;
    this.jobListParams.geoLocation.locShortName = this.locShortName;
    this.jobListParams.Location.latitude = this.userLatitude;
    this.jobListParams.Location.longitude = this.userLongitude;
    vxm.jobs.setFilterRadius(this.range);
    let searchObj = vxm.jobs.searchFilterObj;
    if (searchObj) {
      searchObj.radius = this.range;
    }
    // this.jobListParams.filter.radius = this.range;

    // To default the location
    if (!this.addressSearchText) {
      this.jobListParams.geoLocation.latLong.latitude = vxm.jobs.latitude;
      this.jobListParams.geoLocation.latLong.longitude = vxm.jobs.longitude;
    }

    console.log(this.jobSkillXLArray);
    this.jobListParams.filter.skillTypes = [];
    this.jobSkillXLArray.forEach((s) => {
      this.jobListParams.filter.skillTypes.push(s);
    });

    this.jobListParams.filter.jobTags = this.jobTagsArray.join();

    if (searchObj) {
      searchObj.jobSkills = this.jobListParams.filter.skillTypes;
      searchObj.facilityTypes = this.facilityTypes;
      searchObj.selectedDiscipline = this.selectedDiscipline;
      searchObj.jobTags = this.jobListParams.filter.jobTags;
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////////////

    if (this.industryXL) {
      this.jobListParams.filter.industryTypes = this.industryXL;
    } else {
      this.jobListParams.filter.industryTypes = [];
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////////////

    if (this.shiftXL) {
      if (
        this.jobListParams.filter.shiftTypes.findIndex((elm) => {
          return elm === this.shiftXL;
        }) === -1
      ) {
        this.jobListParams.filter.shiftTypes = [];
        this.jobListParams.filter.shiftTypes.push(this.shiftXL);
      }
      searchObj.shift = this.shiftXL;
    } else {
      this.jobListParams.filter.shiftTypes = [];
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////////////

    if (this.candidatePlacementTypeXL) {
      if (
        this.jobListParams.filter.candidatePlacementTypes.findIndex((elm) => {
          return elm === this.candidatePlacementTypeXL;
        }) === -1
      ) {
        this.jobListParams.filter.candidatePlacementTypes = [];
        this.jobListParams.filter.candidatePlacementTypes.push(
          this.candidatePlacementTypeXL,
        );
        let jobType_ = this.candidatePlacementTypes.find(
          (ele) => ele.value === this.candidatePlacementTypeXL,
        );
        if (searchObj) {
          searchObj.jobType = this.candidatePlacementTypeXL;
        }
      }
    } else {
      this.jobListParams.filter.candidatePlacementTypes = [];
    }
    if (searchObj) {
      searchObj.location = this.addressSearchText;
    }
    searchObj.remoteWorkingJobs = this.remoteJobType;
    this.jobListParams.filter.remoteJobType = this.remoteJobType;
    this.jobListParams.filter.categoryIds = this.removeParentCategoryIds(
      this.selectedCategory,
    );
    this.jobListParams.filter.customFields = {};
    const facilityTypeOptions = vxm.jobs.CustomFilters.find(
      (filter) => filter.displayId === 'customInt5',
    );
    if (
      facilityTypeOptions &&
      this.facilityTypes &&
      this.facilityTypes.length
    ) {
      this.jobListParams.filter.customFields = {
        [facilityTypeOptions.displayId]: { values: this.facilityTypes },
      };
    }
    const disciplineOptions = vxm.jobs.CustomFilters.find(
      (filter) => filter.display === 'Discipline',
    );
    if (disciplineOptions && this.selectedDiscipline) {
      this.jobListParams.filter.customFields = {
        [disciplineOptions.displayId]: {
          values: this.selectedDiscipline ? [this.selectedDiscipline] : [],
        },
      };
    }
    // adding this when jobs per page is changed and clicked on search button
    // initially it will be 10
    this.jobListParams.resultSize = vxm.jobs.JobListParams.resultSize;
    this.fetchJobs(seoFreindlyUrl);
  }

  removeParentCategoryIds(categoriesId) {
    const formattedCategories = categoriesId.map((categoryId) => {
      if (
        vxm.skills.expertiseDataWrapper.categories.find(
          (category) =>
            category.categoryId === categoryId && !category.parentCategoryId,
        )
      ) {
        const childCategoryIds = vxm.skills.expertiseDataWrapper.categories
          .filter((category) => categoryId === category.parentCategoryId)
          .map((category) => {
            return category.categoryId;
          });
        return childCategoryIds.length ? childCategoryIds : categoryId;
      }
      return categoryId;
    });
    return formattedCategories.flat();
  }

  fetchJobs(seoFreindlyUrl = false) {
    const selectedType = this.candidatePlacementTypes.find(
      (type) =>
        type.value === this.jobListParams.filter.candidatePlacementTypes[0],
    );
    const selectedTypeText =
      selectedType && selectedType.text
        ? selectedType.text
            .toLowerCase()
            .replace(/ /g, '-')
            .replace(/\//g, '-')
        : 'any';
    const selectedIndustries =
      (this.industryXL &&
        this.industryXL.map((id) => {
          const option = this.industryVerticals.find(
            (industry) => industry.value === String(id),
          );
          return option && option.text;
        })) ||
      [];
    const selectedIndustriesText = selectedIndustries.length
      ? selectedIndustries
          .join('_')
          .toLowerCase()
          .replace(/ |\//g, '-')
      : 'any';
    const jobSkills =
      (this.jobSkillXLArray &&
        this.jobSkillXLArray.map((id) => {
          const option = this.jobSkills.find(
            (skill) => skill.value === String(id),
          );
          return option && option.text;
        })) ||
      [];
    const jobSkillsText = jobSkills.length
      ? jobSkills
          .join('_')
          .toLowerCase()
          .replace(/ |\//g, '-')
      : 'any';
    const selectedShift = this.shiftTypes.find(
      (type) => type.value === this.shiftXL,
    );
    let shiftText =
      selectedShift && this.shiftXL
        ? selectedShift.name.replace(/ |\//g, '-')
        : 'any';
    shiftText = shiftText.toLowerCase();
    let remoteJobText = this.remoteJobType.length
      ? this.remoteJobType
          .join('_')
          .toLowerCase()
          .replace(/ |\//g, '-')
      : 'any';
    const searchByText = this.jobListParams.keywords
      ? this.jobListParams.keywords
      : 'any';
    const radiusText = this.range;
    const locationText = this.jobListParams.location
      ? this.jobListParams.location.replace(/, /g, '-')
      : 'provided-location';
    const sortOrder = this.jobListParams.sortCriteria.sortOrderAsc
      ? 'ascending'
      : 'descending';
    let sortField = '';
    switch (this.jobListParams.sortCriteria.sortField) {
      case '01':
        sortField = 'date-added';
        break;
      case '02':
        sortField = 'pay';
        break;
      case '03':
        sortField = 'start-date';
        break;
      default:
        sortField = 'date-added';
    }
    let facilityTypesText = this.facilityTypes.length
      ? this.facilityTypes
          .join('_')
          .toLowerCase()
          .replace(/ |\//g, '-')
      : 'any';
    const route = `${selectedTypeText}-placement-type-${encodeURIComponent(
      selectedIndustriesText,
    )}-industry-${jobSkillsText}-jobskill-${shiftText}-shift-${remoteJobText}-remote-job-type-job-search-by-${searchByText}-within-${radiusText}-miles-from-${locationText}-sort-by-${sortField}-in-${sortOrder}-order-${facilityTypesText}-facility-types`;

    let previousRoute = this.$route.name;
    !seoFreindlyUrl && this.$router.push({ path: `/jobs-by-filter/${route}` });
    const copy = JSON.parse(JSON.stringify(this.jobListParams));
    delete copy.filter.remoteJobAvailability;
    if (!copy.filter.remoteJobType) {
      delete copy.filter.remoteJobType;
    }
    if (previousRoute) {
      const respPromise: any = vxm.jobs.reloadJobs(copy);

      const vm = this;
      Promise.all([respPromise]).then(
        (values) => {
          if (values[0].errorCode === '1111') {
            vm.$wlToastr('info', values[0].errorMessage);
          }
        },
        (err) => {
          console.log('Error in Loading Job List', err);
        },
      );
    }

    if (this.jobListParams.keywords != '' || this.addressSearchText != '') {
      this.showJobAlertcard = true;
    } else {
      this.showJobAlertcard = false;
    }
    this.toggleJobAlertLink();
  }

  filterJobsXS() {
    //this.getArray();

    this.jobListParamsXS.resultPage = 1;
    this.jobListParamsXS.resultSize = 5;
    this.jobListParamsXS.geoLocation.requestPref = 'LATLONG';
    this.jobListParamsXS.filter.radius = 5000;

    // To default the location
    if (!this.addressSearchText) {
      this.jobListParams.geoLocation.latLong.latitude = vxm.jobs.latitude;
      this.jobListParams.geoLocation.latLong.longitude = vxm.jobs.longitude;
    }

    if (this.jobListParams.sortCriteria.sortField === '01') {
      this.jobListParams.sortCriteria.sortOrderAsc = true;
    } else {
      this.jobListParams.sortCriteria.sortOrderAsc = false;
    }

    // if (this.jobSkill !== 0) {
    //   if(this.jobListParams.filter.skillTypes.findIndex((elm)=>{return elm === this.jobSkill;}) === -1) {
    //     this.jobListParamsXS.filter.skillTypes = [];
    //     this.jobListParamsXS.filter.skillTypes.push(this.jobSkill);
    //   }
    // } else {
    //   this.jobListParamsXS.filter.skillTypes = [];
    // }
    console.log(this.jobSkillArray);
    this.jobListParamsXS.filter.skillTypes = [];
    this.jobSkillArray.forEach((s) => {
      this.jobListParamsXS.filter.skillTypes.push(s);
    });

    // if (this.industry !== 0) {
    //   if (
    //     this.jobListParams.filter.industryTypes.findIndex((elm) => {
    //       return elm === this.industry;
    //     }) === -1
    //   ) {
    //     this.jobListParamsXS.filter.industryTypes = [];
    //     this.jobListParamsXS.filter.industryTypes.push(this.industry);
    //   }
    // } else {
    //   this.jobListParamsXS.filter.industryTypes = [];
    // }

    if (this.shift !== 0) {
      if (
        this.jobListParams.filter.shiftTypes.findIndex((elm) => {
          return elm === this.shift;
        }) === -1
      ) {
        this.jobListParamsXS.filter.shiftTypes = [];
        this.jobListParamsXS.filter.shiftTypes.push(this.shift);
      }
    } else {
      this.jobListParamsXS.filter.shiftTypes = [];
    }

    if (this.candidatePlacementType) {
      if (
        this.jobListParams.filter.candidatePlacementTypes.findIndex((elm) => {
          return elm === this.candidatePlacementType;
        }) === -1
      ) {
        this.jobListParamsXS.filter.candidatePlacementTypes = [];
        this.jobListParamsXS.filter.candidatePlacementTypes.push(
          this.candidatePlacementType,
        );
      }
    } else {
      this.jobListParamsXS.filter.candidatePlacementTypes = [];
    }

    // adding this when jobs per page is changed and clicked on search button
    // initially it will be 10
    this.jobListParams.resultSize = vxm.jobs.JobListParams.resultSize;

    const copy = JSON.parse(JSON.stringify(this.jobListParamsXS));
    delete copy.filter.remoteJobAvailability;
    const respPromise: any = vxm.jobs.reloadJobs(copy);

    const vm = this;
    Promise.all([respPromise]).then((values) => {
      if (values[0].errorCode === '1111') {
        vm.$wlToastr('info', values[0].errorMessage);
      }
    });
  }

  getAddressData(addressData, placeResultData, id) {
    console.log(placeResultData, '***addressData');
    this.jobListParams.geoLocation.latLong.latitude = addressData.latitude;
    this.jobListParams.geoLocation.latLong.longitude = addressData.longitude;
    this.jobListParams.geoLocation.requestPref = 'LATLONG';
    this.jobListParams.location = placeResultData.formatted_address;
    // console.log(placeResultData.types[0], '***placeResultData.type');
    if (
      placeResultData.types[0] === 'administrative_area_level_1' ||
      placeResultData.types[0] === 'country'
    ) {
      this.isRangeSelectorDisabled = true;
    } else {
      this.isRangeSelectorDisabled = false;
    }

    this.locationType = placeResultData.types[0];
    this.locShortName = placeResultData.address_components[0].short_name;
    if (placeResultData.types[0] === 'locality' && this.range === 3250) {
      this.range = 10;
    }
  }

  getAddressDataXS(addressData, placeResultData, id) {
    this.jobListParamsXS.geoLocation.latLong.latitude = addressData.latitude;
    this.jobListParamsXS.geoLocation.latLong.longitude = addressData.longitude;
    this.jobListParamsXS.geoLocation.requestPref = 'LATLONG';
    this.jobListParamsXS.location =
      addressData.route +
      ', ' +
      addressData.locality +
      ', ' +
      addressData.administrative_area_level_1;
    console.log('AddressData', addressData);
    console.log('JobList', this.jobListParamsXS);
  }

  showRangeBody() {
    this.panelBodyVisibility = true;
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get jfWrapper() {
    return vxm.jobs.jfWrapper;
  }

  get candidatePlacementTypes(): JobFilter[] {
    return vxm.jobs.jfWrapper.candidatePlacementTypes;
  }

  get sortingOptions(): JobFilter[] {
    return vxm.jobs.jfWrapper.sortingOptions;
  }

  get industryVerticals(): JobFilter[] {
    return vxm.jobs.jfWrapper.industryVerticals;
  }

  get isShiftFilterEnabled(): boolean {
    return false
  }
  get datePosted(): JobFilter[] {
    return vxm.jobs.jfWrapper.datePosted;
  }

  get jobSkills(): JobFilter[] {
    let skillDropdownValues: JobFilter[] = vxm.jobs.jfWrapper.jobSkills;
    if (!this.industryXL || (this.industryXL && this.industryXL.length == 0)) {
      return this.lodash.uniqBy(skillDropdownValues, 'text');
    }
    let industries = new Set();
    if (Array.isArray(this.industryXL)) {
      industries = new Set(this.industryXL);
    } else {
      industries = new Set([this.industryXL]);
    }
    const industryid = parseInt(this.industryXL + '');
    let jobSkillxlArr = this.lodash.cloneDeep(this.jobSkillXLArray);
    jobSkillxlArr = jobSkillxlArr.filter((skillId) => {
      const size = skillDropdownValues.length;
      for (let i = 0; i < size; i++) {
        let skillEntry: JobFilter = skillDropdownValues[i];
        let skillTypeId = parseInt(skillEntry.value);
        let referenceId = parseInt(skillEntry.reference);
        if (
          skillId == skillTypeId &&
          (industries.has(referenceId) || industries.has(referenceId + ''))
        ) {
          return true;
        }
      }
      return false;
    });
    let vl = skillDropdownValues.filter((skillEntry) => {
      let referenceId = parseInt(skillEntry.reference);
      if (industries.has(referenceId) || industries.has(referenceId + '')) {
        return true;
      }
      return false;
    });
    this.jobSkillXLArray = this.lodash.cloneDeep(jobSkillxlArr);
    return this.lodash.uniqBy(vl, 'text');
  }

  get jobTags(): JobFilter[] {
    if (vxm.jobs.jfWrapper.jobTags && vxm.jobs.jfWrapper.jobTags.length > 0) {
      return vxm.jobs.jfWrapper.jobTags.map((tag) => {
        tag.value = tag.text;
        return tag;
      });
    }
    return [];
  }

  onAddressTextChange(text: string) {
    this.addressSearchText = text;
    if (!text) {
      this.jobListParams.geoLocation.latLong = {};
      this.jobListParams.location = '';
    }
  }

  onNoResults() {
    this.$wlToastr('error', this.$t('please-enter-valid-location-error-text'));
  }

  async mounted() {
    const token = vxm.users.getToken;
    this.minimumSearchDistance = parseInt(vxm.jobs.getCompanyRadiusMin);
    this.maximumSearchDistance = parseInt(vxm.jobs.getCompanyRadiusMax);
    if (vxm.jobs.JobListParams) {
      const jobListParams = vxm.jobs.JobListParams;
      let searchObj = vxm.jobs.searchFilterObj;
      this.jobTagsArray = searchObj.jobTags
        ? Array.isArray(searchObj.jobTags)
          ? searchObj.jobTags
          : searchObj.jobTags.split(',')
        : [];
      this.candidatePlacementTypeXL =
        jobListParams.filter.candidatePlacementTypes[0] || '';
      this.jobSkillXLArray =
        searchObj.jobSkills ||
        (jobListParams &&
          jobListParams.filter &&
          jobListParams.filter.skillTypes);
      this.industryXL =
        searchObj.industry ||
        (jobListParams &&
          jobListParams.filter &&
          jobListParams.filter.industryTypes);
      this.selectedCategory = searchObj.categories;
      this.shiftXL = searchObj.shift || '';
      this.facilityTypes = searchObj.facilityTypes || [];
      this.selectedDiscipline = searchObj.selectedDiscipline || '';
      this.range = searchObj.radius;
      !searchObj.radius &&
        vxm.jobs.setFilterRadius(parseInt(vxm.jobs.getCompanyRadiusMax));
      this.remoteJobType =
        searchObj.remoteWorkingJobs || jobListParams.filter.remoteJobType;
      console.log(' this.remoteJobType ' + this.remoteJobType);
      this.jobListParams = vxm.jobs.JobListParams;
      this.jobListParams.sortCriteria.sortField = '01';
      this.addressSearchText = searchObj.location;
      let addressElem = this.$refs.address_filter;
      addressElem.update(searchObj.location);
      this.skillid = parseInt(this.$route.params.SkillID);
      this.industryid = parseInt(this.$route.params.IndustryID);
      this.cityId = parseInt(this.$route.params.CityId);

      console.log('... cityId :: ', this.cityId);
      if (this.cityId > 0) {
        console.log('calling cityId :: ', this.cityId);
        vxm.jobs.setCityId(this.cityId);
        this.jobListParams.filter.facilityId = this.cityId;
        this.jobListParamsXS.filter.facilityId = this.cityId;
        vxm.jobs.setJobListParams(this.jobListParams);
        vxm.jobs.setFilterRadius(10);
        this.range = 10;
        //vxm.jobs.setFilterRadius(10);
      }

      if (this.skillid > 0) {
        console.log('skillid : ', this.skillid);
        this.jobListParams.filter.skillTypes = [];
        this.jobListParams.filter.skillTypes.push(this.skillid);
        searchObj.skillTypes = this.jobListParams.filter.skillTypes;

        if (searchObj) {
          searchObj.jobSkills = this.jobListParams.filter.skillTypes;
        }
        this.jobSkillXLArray = [this.skillid + ''];
        vxm.jobs.setSkillTypeId(this.skillid);
        //vxm.jobs.setFilterRadius(10);
      }

      if (this.industryid > 0) {
        console.log('industryid : ', this.industryid);
        this.jobListParams.filter.industryTypes = [];
        this.jobListParams.filter.industryTypes.push(this.industryid);
        this.industryXL = [this.industryid + ''];
        vxm.jobs.setIndustryTypeId(this.industryid);
        //vxm.jobs.setFilterRadius(10);
      }

      const locationText = this.$route.params.location;

      if (locationText) {
        this.jobListParams.location = locationText;
        this.$refs.address_filter.update(locationText);
        this.addressSearchText = locationText;
        const response = await vxm.utility.getLatitudeLongitude({
          locationText,
        });
        this.jobListParams.geoLocation.latLong.latitude = response.latitude;
        this.jobListParams.geoLocation.latLong.longitude = response.longitude;
        this.locationType = response.locationType;
        this.locShortName = response.locShortName;
        this.range = 10;
      }

      if (!this.range) {
        this.range = parseInt(vxm.jobs.getCompanyRadiusMax);
      }

      if (
        this.jobListParams.sortCriteria &&
        this.jobListParams.sortCriteria.sortOrderAsc &&
        (this.jobListParams.sortCriteria.sortField === '03' ||
          this.jobListParams.sortCriteria.sortField === '01')
      ) {
        this.activeAscColor = this.INACTIVE_SORT_COLOR_CODE;
        this.activeDescColor = this.ACTIVE_SORT_COLOR_CODE;
      } else if (
        this.jobListParams.sortCriteria &&
        !this.jobListParams.sortCriteria.sortOrderAsc &&
        (this.jobListParams.sortCriteria.sortField === '03' ||
          this.jobListParams.sortCriteria.sortField === '01')
      ) {
        this.activeAscColor = this.ACTIVE_SORT_COLOR_CODE;
        this.activeDescColor = this.INACTIVE_SORT_COLOR_CODE;
      } else if (
        this.jobListParams.sortCriteria &&
        this.jobListParams.sortCriteria.sortOrderAsc
      ) {
        this.activeAscColor = this.ACTIVE_SORT_COLOR_CODE;
        this.activeDescColor = this.INACTIVE_SORT_COLOR_CODE;
      } else if (
        this.jobListParams.sortCriteria &&
        !this.jobListParams.sortCriteria.sortOrderAsc
      ) {
        this.activeAscColor = this.INACTIVE_SORT_COLOR_CODE;
        this.activeDescColor = this.ACTIVE_SORT_COLOR_CODE;
      }
    } else {
      this.jobFilterWrapper = vxm.jobs.jfWrapper;
      this.jobListParams.geoLocation.latLong.latitude = vxm.jobs.latitude;
      this.jobListParams.geoLocation.latLong.longitude = vxm.jobs.longitude;
      this.jobListParamsXS.geoLocation.latLong.latitude = vxm.jobs.latitude;
      this.jobListParamsXS.geoLocation.latLong.longitude = vxm.jobs.longitude;
    }
    //this.range = this.appliedFilterRadius;

    if (
      !(this.jobListParams.keywords == '') ||
      !(this.addressSearchText == '')
    ) {
      this.showJobAlertcard = true;
      console.log('setting alert card true');
    } else {
      this.showJobAlertcard = false;
      console.log('setting alert card false');
    }
    if (vxm.users.isLoggedIn) {
      const respPromise: any = vxm.jobs.getJobAlerts(
        vxm.users.myUserProfile.email,
      );
      Promise.all([respPromise]).then(
        (response) => {
          if (response) {
            console.log('resonse is:' + response[0].jobAlerts);
            vxm.jobs.setJobAlerts(response[0].jobAlerts);
          }
        },
        (err) => {
          console.log('Error in Loading Job List');
        },
      );
    }
    if (this.jobAlertId) {
      let resp = await vxm.jobs.getJobAlert(this.jobAlertId);
      console.log('Received alert : ', resp);
      this.jobListParams.keywords = resp.name;
      this.addressSearchText = resp.alertConfigDetails.address;
      this.$refs.address_filter.update(resp.alertConfigDetails.address);
      if (this.addressSearchText) {
        this.jobListParams.geoLocation.latLong.latitude =
          resp.alertConfigDetails.latLong.latitude;
        this.jobListParams.geoLocation.latLong.longitude =
          resp.alertConfigDetails.latLong.longitude;
      }
      this.jobListParams.sortCriteria.sortField === '01';
      this.remoteJobType = resp.filter.remoteJobType;
      //this.filterJobs();
      setTimeout(() => this.filterJobs(), 3000);
    }
    try {
      const response = await vxm.skills.getCategoryExpertiseData({
        parentCategoryId: null,
        searchAllCategories: true,
      });
      this.categories = this.formatCategories(response.categories || []);
    } catch (e) {
      console.log(e);
    }
    if (this.isSeoFriendlyUrl) {
      this.filterJobs(this.isSeoFriendlyUrl);
    }
    this.onGetCandidatePlacementTypes();
  }

  get isSeoFriendlyUrl() {
    return (
      this.$route.name === 'JobsBySkillId' ||
      this.$route.name === 'JobsByIndustryId' ||
      this.$route.name === 'JobsByIndustryLocation' ||
      this.$route.name === 'JobsBySkillLocation' ||
      this.$route.name === 'JobsByLocation'
    );
  }

  ///////////////////////////////// Job Alert Methods ////////////////////////////////////
  private showJobAlertcard: boolean = false;
  private commonJobAlert: CommonJobAlert = new CommonJobAlert();
  private showJobAlertLink: boolean = false;

  get displayJobAlertCard() {
    let jobAlertMenu: any = 'false';
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      jobAlertMenu = vxm.configs.ClientConfigs.slideMenuOptions.find(
        (menu) => menu.sectionKey === 'JOB_ALERTS',
      );
    } else {
      jobAlertMenu = vxm.utility.leftMenuOptions.find(
        (menu) => menu.alias === 'job_alerts',
      );
    }
    return (
      jobAlertMenu && jobAlertMenu.signInVisibility && this.showJobAlertcard
    );
  }

  toggleJobAlertLink() {
    console.log(
      'this.jobListParams.keywords' +
        this.jobListParams.keywords +
        '  this.addressSearchText; ' +
        this.addressSearchText,
    );
    if (this.jobListParams.keywords === undefined) {
      console.log('address text is undefined');
    }
    if (this.jobListParams.keywords == '') {
      console.log('address text is empty');
    }

    this.showJobAlertLink = false;
    vxm.jobs.UserJobAlerts.forEach((item, index) => {
      //vxm.jobs.JobListParams.keywords
      //vxm.jobs.JobListParams.location

      if (this.jobListParams.keywords == '' || this.addressSearchText == '') {
        if (this.jobListParams.keywords == '') {
          if (this.addressSearchText != '') {
            console.log(
              'this.addressSearchText :' +
                this.addressSearchText +
                ' item.alertConfigDetails.address:' +
                item.alertConfigDetails.address +
                ' item.name:' +
                item.name,
            );
            if (
              item.alertConfigDetails.address == this.addressSearchText &&
              item.name === 'All Jobs'
            ) {
              this.showJobAlertLink = true;
            }
          }
        }
        if (this.addressSearchText == '') {
          console.log('this is true');
          if (this.jobListParams.keywords != '') {
            if (item.name === this.jobListParams.keywords) {
              this.showJobAlertLink = true;
            }
          }
        }
      } else if (
        item.name === this.jobListParams.keywords &&
        item.alertConfigDetails.address === this.addressSearchText
      )
        this.showJobAlertLink = true;
    });
    console.log('this.showJobAlertLink:' + this.showJobAlertLink);
  }

  isKeywordEntered() {
    if (!this.jobListParams.keywords) return false;
    else return true;
  }

  isSearchTextEntered() {
    if (!this.addressSearchText) return false;
    else return true;
  }

  get keywords() {
    if (this.jobListParams.keywords == '') return 'All Jobs';
    else return this.jobListParams.keywords;
  }

  get searchText() {
    return this.addressSearchText;
  }

  get alertText() {
    let text = `${this.$t('searchbox-showing-jobs-text')} `;
    if (this.jobListParams.keywords != '') {
      text += `${this.$t('searchbox.for.text')} ` + this.jobListParams.keywords;
    }

    if (this.addressSearchText != '') {
      text += ` ${this.$t('searchbox-in-and-around-text')} ` + this.addressSearchText;
    }
    return text;
  }

  get remoteJobTypes() {
    return [
      { value: 'yes', text: 'Yes' },
      { value: 'no', text: 'No' },
      { value: 'partial', text: 'Partial' },
    ];
  }

  createJobAlert() {
    console.log('Test', vxm.jobs.JobListParams);
    if (!this.jobListParams.keywords && !this.addressSearchText) {
      //if (!vxm.jobs.JobListParams.keywords && !vxm.jobs.JobListParams.location) {
      this.$wlToastr(
        'error',
        this.$t('JobAlert_MandatoryTitleOrLocationMsg').toString(),
        this.$t('JobAlert_JobAlert').toString(),
      );
      return;
    }

    let locale = new Locale();
    locale.city = '';
    locale.state = '';
    locale.country = '';

    let latlong = new Latlong();
    /*if (!this.addressSearchText) {
        latlong.latitude = vxm.jobs.latitude;
        latlong.longitude = vxm.jobs.longitude;
      }*/
    latlong.latitude = this.jobListParams.geoLocation.latLong.latitude;
    latlong.longitude = this.jobListParams.geoLocation.latLong.longitude;
    /*  latlong.latitude = vxm.jobs.JobListParams.geoLocation.latLong.latitude;
    latlong.longitude = vxm.jobs.JobListParams.geoLocation.latLong.longitude;*/

    let geoLocation = new Geolocation();
    geoLocation.requestPref = 'LATLONG';
    geoLocation.locale = this.jobListParams.geoLocation.locale;
    // geoLocation.locale = vxm.jobs.JobListParams.geoLocation.locale;
    geoLocation.latLong = latlong;
    geoLocation.locationType = '';
    geoLocation.locShortName = '';

    let alertConfigDetails = new AlertConfigDetails();
    //alertConfigDetails.textCriteria = this.jobListParams.keywords;
    // alertConfigDetails.address  = this.addressSearchText;
    if (this.jobListParams.keywords) {
      alertConfigDetails.textCriteria = this.jobListParams.keywords;
    }
    alertConfigDetails.address = this.addressSearchText; //vxm.jobs.JobListParams.location;
    alertConfigDetails.latLong = latlong;
    alertConfigDetails.geoLocation = geoLocation;

    let jobAlert = new JobAlertUI();
    //jobAlert.name = this.jobListParams.keywords;
    if (!this.jobListParams.keywords) {
      jobAlert.name = 'All Jobs';
    } else {
      jobAlert.name = this.jobListParams.keywords;
    }
    jobAlert.email = vxm.users.myUserProfile.email;
    jobAlert.fullName =
      vxm.users.myUserProfile.firstName +
      ' ' +
      vxm.users.myUserProfile.lastName;
    jobAlert.companyCode = vxm.jobs.BrandingInfo.companycode;
    jobAlert.alertConfigDetails = alertConfigDetails;
    jobAlert.status = 0;
    jobAlert.isActive = true;
    jobAlert.isValidated = false;
    jobAlert.filter.remoteJobType = Array.isArray(this.remoteJobType)
      ? this.remoteJobType
      : [];
    this.commonJobAlert.jobAlert = jobAlert;
    this.saveJobAlert();
  }

  validateJobAlert(): boolean {
    return true;
  }
  getCompanyDistanceUnits(): string {
    let temp = vxm.jobs.getCompanyDistanceUnit;
    return temp.charAt(0).toUpperCase() + temp.slice(1);
  }

  saveJobAlert() {
    if (this.validateJobAlert()) {
      vxm.jobs.createCommonJobAlert(this.commonJobAlert).then((res) => {
        console.log('Job Alert Respons', res);
        if (res.success === true) {
          this.commonJobAlert.jobAlert.id = res.jobAlertId;
          vxm.jobs.UserJobAlerts.push(this.commonJobAlert.jobAlert);
          this.toggleJobAlertLink();
          this.$wlToastr('success', '', this.getJobAlertSuccessMessage());
          this.commonJobAlert = new CommonJobAlert();
        } else {
          let errorMessage = this.lodash.isEmpty(res.errorMessage)
            ? 'Error Creating Job Alert'
            : res.errorMessage;
          this.$wlToastr(
            'error',
            errorMessage,
            this.$t('JobAlert_JobAlert').toString(),
          );
        }
      });
    }
  }

  getJobAlertSuccessMessage() {
    if (vxm.users.isLoggedIn) {
      return this.$t('jobalert-created-success-message').toString();
    }
    return this.$t('jobalert-created-anon-success-message').toString();
  }

  clearFilters() {
    this.$refs.address_filter.update('');
    this.onAddressTextChange('');
    this.selectedCategory = [];
    this.facilityTypes = [];
    this.selectedDiscipline = '';
    this.panelBodyVisibility = false;
    this.jobListParams.resultPage = 1;
    this.jobListParams.geoLocation.requestPref = 'LATLONG';
    this.jobListParams.geoLocation.locationType = '';
    this.jobListParams.geoLocation.locShortName = '';
    this.jobListParams.Location.latitude = 0.0;
    this.jobListParams.Location.longitude = 0.0;
    vxm.jobs.setFilterRadius(this.range);
    let searchObj = vxm.jobs.searchFilterObj;
    if (searchObj) {
      searchObj.radius = this.range;
    }
    // this.jobListParams.filter.radius = this.range;

    // To default the location
    if (!this.addressSearchText) {
      this.jobListParams.geoLocation.latLong.latitude = vxm.jobs.latitude;
      this.jobListParams.geoLocation.latLong.longitude = vxm.jobs.longitude;
    }

    this.jobListParams.filter.skillTypes = [];

    this.jobListParams.filter.industryTypes = [];

    this.jobListParams.filter.shiftTypes = [];
    this.jobListParams.filter.candidatePlacementTypes = [];

    if (searchObj) {
      searchObj.location = this.addressSearchText;
    }
    searchObj.remoteWorkingJobs = this.remoteJobType;
    this.jobListParams.filter.remoteJobType = this.remoteJobType;
    // adding this when jobs per page is changed and clicked on search button
    // initially it will be 10
    this.jobListParams.resultSize = 10;
    this.jobListParams.keywords = '';
    this.candidatePlacementTypeXL = '';
    this.industryXL = [];
    this.jobSkillXLArray = [];
    this.jobListParams.sortCriteria.sortField = '01';
    this.jobListParams.sortCriteria.sortOrderAsc = true;
    this.industry = 0;
    this.shift = 0;
    this.jobSkill = 0;
    this.jobSkillArray = [];
    this.candidatePlacementType = '';

    this.industryXL = [];
    this.remoteJobType = [];
    this.shiftXL = '';
    this.jobSkillXL = 0;
    this.jobSkillXLArray = [];
    this.candidatePlacementTypeXL = '';
    this.addressSearchText = '';
    this.range = Number(window.WorkLLama.isConfigJSONEnabled === 'true' ? vxm.configs.ClientConfigs.companyPreference.companyRadiusMax : vxm.jobs.BrandingInfo.COMPANY_RADIUS_MAX) || 3250;
    this.panelBodyVisibility = false;
    this.minimumSearchDistance = 5;
    this.maximumSearchDistance =
      Number(window.WorkLLama.isConfigJSONEnabled === 'true' ? vxm.configs.ClientConfigs.companyPreference.companyRadiusMax : vxm.jobs.BrandingInfo.COMPANY_RADIUS_MAX) || 3250;
    this.isRangeSelectorDisabled = false;
    this.locationType = '';
    this.jobType = 'Job Type';
    vxm.jobs.setSearchFilterObj({
      jobTitle: '',
      location: '',
      jobType: '',
      jobSkills: [],
      industry: '',
      radius: '',
      sort: '',
      remoteWorkingJobs: '',
      categories: [],
      facilityTypes: [],
    });
  }

  destroyed() {
    vxm.jobs.setSearchFilterObj({
      ...vxm.jobs.searchFilterObj,
      categories: [],
    });
  }
}
